<template>
    <select id="ubahKantor" name="ubahKantor" v-model="kid" @change="changeSetting()" class="form-control "> 
      <option disabled>-- PILIH TAMPILAN --</option>
      <option value="10000" selected="selected">SEMUA</option>
      <option value="19">Banda Aceh (Pusat)</option>
      <option value="21">Lhokseumawe</option> 
    </select>
</template>

<script>

    export default {
      data () {
        return {
          kid:"10000",
        }
      },
      methods: {
        changeSetting() {
          this.$root.$emit('myEvent', this.kid);
        },
      },
      mounted() {
           
      },
      created() {
        //console.log("switcher");
      }
    }
</script>
